import "@fontsource-variable/inter";
import "@fontsource/barlow-condensed/latin-700.css";
import "@fontsource/barlow-condensed/latin-800.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initializeGoogleAds } from "./lib/google-ads";
import "./styles/index.css";

// Idempotent fallback if the app entry executes before the head bootstrap.
initializeGoogleAds();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
